import React, { FC, useState } from 'react'

import { Modal, Txt, StandardButton, Icon } from 'src/components/atoms'

import { useGetExternalUsers, useUser } from 'src/hooks'
import { ExternalUserEntity } from 'src/types'

type Props = {
  externalUsers: ExternalUserEntity[]
  isOpen: boolean
  onClose: () => void
  afterDelete?: () => void
}

export const DeleteExternalUserModal: FC<Props> = ({
  externalUsers,
  isOpen,
  onClose,
  afterDelete,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { deleteUser } = useUser()
  const { refetch } = useGetExternalUsers()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await Promise.all(externalUsers.map(externalUser => deleteUser({ userId: externalUser.id })))
      await refetch()
      afterDelete && afterDelete()
    } catch (error) {
      console.log('e: ', error)
    } finally {
      setIsDeleting(false)
      onClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              社外ユーザー削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[37.86rem] tw-p-s2">
        <Txt>ユーザー削除を実行すると情報の復元はできません。本当によろしいですか？</Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除する"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
